import { useEffect, useRef } from "react";
import { useReleaseNotes } from "./useReleaseNotes";

export const useReleaseSpotlight = () => {
  const { recentSpotlightId, open } = useReleaseNotes();
  const hasOpenedRef = useRef(false);

  useEffect(() => {
    if (!recentSpotlightId || hasOpenedRef.current) return;
    hasOpenedRef.current = true;
    open(recentSpotlightId);
  }, [recentSpotlightId, open]);
};
